import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

//get items from Item master with pagination
export const getItems = async (limit = 2000, lastEvaluatedKey = null) => {
    try {
        
        const params = {
            limit:limit,
            lastEvaluatedKey:lastEvaluatedKey
        };

        //const response = await axios.post(`${API_URL}/itemsmaster/getitems`, { params });
        const response = await axios.post(
            `${API_URL}/itemsmaster/getitems`,
            params
        );
        
        return response.data;
    } catch (error) {
        console.error("Error fetching items:", error);
        
        return { items: [], lastEvaluatedKey: null };
    }
}; 